const overseasNewsRouter = {
  title: '出海资讯管理',
  type: 'view',
  name: 'overseasNewsList',
  route: '/overseas-news/list',
  filePath: 'view/overseas_news/list.vue',
  order: 7,
  inNav: true,
  icon: 'iconfont el-icon-document',
  permission: ['查询出海资讯'],
}

export default overseasNewsRouter
